<template>
  <div class="telegram column">
    <div class="text-center">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <defs>
          <linearGradient id="a" x1=".667" x2=".417" y1=".167" y2=".75">
            <stop offset="0" stop-color="#37aee2" />
            <stop offset="1" stop-color="#1e96c8" />
          </linearGradient>
          <linearGradient id="b" x1=".66" x2=".851" y1=".437" y2=".802">
            <stop offset="0" stop-color="#eff7fc" />
            <stop offset="1" stop-color="#fff" />
          </linearGradient>
        </defs>
        <circle cx="120" cy="120" r="120" fill="url(#a)" />
        <path fill="#c8daea" d="M98 175c-3.888 0-3.227-1.468-4.568-5.17L82 132.207 170 80" />
        <path fill="#a9c9dd" d="M98 175c3 0 4.325-1.372 6-3l16-15.558-19.958-12.035" />
        <path
          fill="url(#b)"
          d="M100.04 144.41l48.36 35.729c5.519 3.045 9.501 1.468 10.876-5.123l19.685-92.763c2.015-8.08-3.08-11.746-8.36-9.349l-115.59 44.571c-7.89 3.165-7.843 7.567-1.438 9.528l29.663 9.259 68.673-43.325c3.242-1.966 6.218-.91 3.776 1.258"
        />
      </svg>
    </div>

    <h3>Autorização Notificações via Telegram</h3>
    <div class="divider"></div>
    <div class="content">
      Olá
      <strong>{{user.nome}}</strong> !
      <br />
      <p>
        Disponibilizamos para você mais um canal de interação com a
        NetSupport através da nossa assistente virtual NeTI.
      </p>
      <p>
        Ela poderá te enviar ofertas de jobs e notificações diretamente para seu
        telefone via Telegram.
      </p>
    </div>

    <div class="divider"></div>
    <div class="row column-s justify-around align-center" style="margin-top: 20px">
      <a :href="user.url_autorizacao_telegram + user.id_doutor" target="_blank">
        <Button layout="green-go" @click="NOTIFY_TELEGRAM(true);modal.show=false">Autorizar</Button>
      </a>
      <Button layout="red-s" @click="NOTIFY_TELEGRAM(false);modal.show=false">Não autorizar</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button.vue";
export default {
  name: "Telegram",
  components: { Button },
  props: {
    modal: Object
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("user", ["NOTIFY_TELEGRAM"])
  },
  computed: {
    ...mapGetters("user", ["user"])
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.telegram {
  svg {
    width: 100px;
  }
  text-align: center;
  padding-top: 25px;
  color: $gray-6;
  padding: 10px 30px;
  padding-top: 25px;
  padding-bottom: 25px;
  max-width: 600px;
  @media (min-width: $small) {
    /* width: 50%; */
    width: 600px;
  }
  .content {
    /*   text-align: justify; */
    padding: 25px;
    padding-bottom: 15px;
    font-size: 14px;
  }
  .button-green-go {
    height: 30px;
    padding-top: 8px;
    width: 128px;
    font-size: 13px;
    max-width: 600px;
    @media (max-width: $small) {
      margin-bottom: 20px;
    }
  }
}
</style>